import { z } from 'zod';

import {
  MODIFIER_TAP_CONSUMERS,
  isModifierCombo,
} from '../../shared/ipc.types';

export const ApiConfigPayload = z.object({
  token: z.string(),
  url: z.string(),
  appVersion: z.string(),
});

export const ContentFiltersUpdatePayload = z.object({
  setting: z.string(),
  rules: z.string(),
});

export const RunObserverPayload = z.object({
  path: z.string(),
});

export const UserEmailPayload = z.object({
  email: z.string(),
  id: z.string(),
  isInternal: z.boolean(),
});

export const AuthTokensExpiredPayload = z.object({
  reason: z.string(),
  error: z.string().optional(),
});

export const ClearAuthPayload = z.object({
  reason: z.string(),
});

export const UpdateStatusPayload = z.object({
  updateStatus: z.string(),
  newVersion: z.string().optional(),
  downloadProgress: z.number().optional(),
});

export const TraverseAppPayload = z.object({
  pid: z.number().int().positive(),
  windowId: z.number().int().positive().optional(),
  traverseAllWindows: z.boolean().optional(),
});

export const PasteTextPayload = z.object({
  text: z.string(),
});

export const DeleteContextPayload = z.object({
  deleteFrom: z.number().int().nonnegative().optional(),
  deleteTo: z.number().int().nonnegative().optional(),
});

export const ConfigureModifierTapMonitorPayload = z.object({
  consumer: z.enum(MODIFIER_TAP_CONSUMERS),
  modifier: z.string().refine(isModifierCombo, 'not a modifier combo'),
  gesture: z.enum(['taps', 'hold']),
  requiredTaps: z.number().int().min(1).max(5),
  tapInterval: z.number().min(0.1).max(1.0),
  maxHoldDuration: z.number().min(0.1).max(1.0),
});

export const StopModifierTapMonitorPayload = z.object({
  consumer: z.enum(MODIFIER_TAP_CONSUMERS).optional(),
});

export const SubscriptionPlanPayload = z.object({
  subscriptionPlan: z.string().nullable().optional(),
});
